import { render, staticRenderFns } from "./MateriaPage.vue?vue&type=template&id=5368b312"
import script from "./MateriaPage.js?vue&type=script&lang=js&external"
export * from "./MateriaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports